export enum WidgetSize {
  SMALL = 'SMALL',
  LARGE = 'LARGE',
  XLARGE = 'XLARGE'
}
